import React from 'react';

//import { Link } from "react-router-dom";

import Logo from '../images/tvw-logo.png';

const AnmeldungErfolgreich = (props) => {
    return (
        <div className="jh-content">
            <div className="row">
                <h1>Anmeldung erfolgreich!</h1>

                <p>Vielen Dank für die Anmeldung. Wir haben die Daten erfolgreich im System gespeichert. Eine Bestätigungsmail ist auf dem Weg.</p>
                <img src={Logo} className="img-fluid rounded mx-auto d-block" alt="Logo des Bike Teams Weiler i.d.B." />
                
            </div>
        </div>
    );
}

export default AnmeldungErfolgreich;


// WEBPACK FOOTER //
// ./src/components/AnmeldungErfolgreich.js